// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3OZvn","itemTitle":"ClientEmergencyInfo_itemTitle__2xZ6D","itemText":"ClientEmergencyInfo_itemText__3fgm6"};